<div class="calendar-container">
  <app-slider-navigation class="navigation general-container" (direction)="navigate($event)"></app-slider-navigation>
  <swiper-container #swiperRef [config]="slideOpts" pager="true">
    <swiper-slide *ngFor="let date of dates; let index = index">
      <app-calendar-card [startDate]="date" [dateClass]="dateClass"></app-calendar-card>
    </swiper-slide>
  </swiper-container>
</div>